import css from "../../css/listing/right-form.module.css";

import React from "react";
import PropTypes from "prop-types";
import RequestForm from "./RequestForm";
import Agent from "./Agent";
import User from "./User";
import { OWNER_TYPE, MANAGER_TYPE } from "../../service/my-property";

const RightForm = (props) => {
    const { listing } = props;
    const { agent, owner_user, manager_user, market_share_agents } = listing;

    let marketShareAgents = [];

    if (market_share_agents && market_share_agents.length > 0) {
        for (let marketShareAgent of market_share_agents) {
            marketShareAgents.push(
                <div
                    className={css.agent}
                    style={{ marginTop: "30px" }}
                    key={marketShareAgent.id}
                >
                    <Agent
                        agent={marketShareAgent}
                        listing={listing}
                        isPrimary={false}
                        isMarketShareAgent={true}
                    />
                </div>
            );
        }
    }

    return (
        <div className={css.rightForm}>
            {agent && (
                <div className={css.agent}>
                    <Agent agent={agent} listing={listing} isPrimary={true} />
                </div>
            )}
            {!agent && (
                <>
                    {manager_user && (
                        <div className={css.agent}>
                            <User user={manager_user} type={MANAGER_TYPE} />
                        </div>
                    )}
                    {owner_user && !manager_user && (
                        <div className={css.agent}>
                            <User user={owner_user} type={OWNER_TYPE} />
                        </div>
                    )}
                </>
            )}
            {marketShareAgents.length > 0 && marketShareAgents}
            {(agent || manager_user || owner_user) && (
                <RequestForm listing={listing} />
            )}
        </div>
    );
};

RightForm.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default RightForm;
